/**
 @ngdoc service
 @name Key Value Object Service

 @description
 Was finding I replicating to many method calls inside bulk

 @example
 var rowIdSet = {1: true,  2: true,  3: true,  4: true,  5: true,  6: true,  7: true,  8: true, 9: true,  10: true,  11: true,  12: true,  13: true, 14: true,  15: true,  16: true,  17: true,  18: true, 19: true,  20: true, 33: true,  34: true, 35: true,  36: true,  37: true,  38: true,  39: true, 40: true,  41: true,  42: true,  43: true,  44: true};
 console.log( keyValueObjectService.splitKeys( rowIdSet, 7, true ) );
 console.log( keyValueObjectService.splitKeys( rowIdSet, 31, true ) );
 console.log( keyValueObjectService.splitKeys( rowIdSet, 32, true ) );
 console.log( keyValueObjectService.splitKeys( rowIdSet, 33, true ) );
 */
angular.module('app').service('keyValueObjectService', function() {
    //private var for debugging file
    var DEBUG = false;

    /**
     * Split a key value object up after the nth key
     * @param keyValueObject
     * @param maxKeySize
     * @param evenly ~ true: Share the keys as evenly as possibly. Splitting the keys evenly won't maintain the order. false: Will maintain order, but last split will be smaller than rest
     * @returns {Array}
     */
    this.splitKeys = function (keyValueObject, maxKeySize, evenly) {
        var keyValueObjectList = [];
        // Identify how many keys currently
        var currentKeySize = Object.keys(keyValueObject).length;
        log('currentKeySize',currentKeySize);

        if( currentKeySize <= maxKeySize ){
            //No need to split
            keyValueObjectList.push( keyValueObject )
        } else {
            // Identify how many splits we'll need
            var numberOfSplits  = Math.ceil(currentKeySize/maxKeySize);
            log('numberOfSplits',numberOfSplits);
            /// First index point to begin a split
            var splitKeysAtIndex = Math.ceil(currentKeySize/numberOfSplits);
            log('splitKeysAtIndex',splitKeysAtIndex);
            // Initialise our even split of new Key Value Objects
            for (var idx = 0; idx < numberOfSplits; idx++) {
                keyValueObjectList.push({});
            }
            // Loop through each Key Value of the object
            var counter = 0;
            var partIndex;
            for(var keyValue in keyValueObject){
                if(evenly) {
                    if( counter === numberOfSplits){
                        counter = 0;
                    }
                    partIndex = counter;
                } else {
                    partIndex = Math.floor(counter/splitKeysAtIndex);
                }
                counter++;
                //Adds the reference to value. It DOES NOT clone!
                keyValueObjectList[partIndex][keyValue] = keyValueObject[keyValue];

            }
        }
        log('keyValueObjectList',keyValueObjectList);
        return keyValueObjectList;
    };

    /**
     * Looping keys and when finding a match running a user defined function
     * @param rowIdSet
     * @param dataList
     * @param colKey
     * @param myFunction
     * @param passedDataModel
     */
    this.loopData = function(rowIdSet, dataList, colKey, myFunction, passedDataModel){
        var row, cell;
        for (var rowId in rowIdSet) {
            log('rowId',rowId);
            for (var rowIdx in dataList) {
                log('rowIdx',rowIdx);
                row = dataList[rowIdx];
                log('row',row);
                cell = row[colKey];
                log('cell',cell);
                if( row.id.value == rowId ){ //matched row
                    myFunction(row, cell, passedDataModel);
                }
            }
        }
    };

    var log = function(identifier,data){
        if(DEBUG) console.log(identifier,data);
    };
});